import * as React from "react";

function SvgCheckcircle(props) {
  return (
    <span className="iiht-svg">
      <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} {...props}>
        <path
          d="M8 16a8 8 0 118-8 8.009 8.009 0 01-8 8zM3.5 8.975a.5.5 0 00-.355.855l2.486 2.37a.5.5 0 00.708 0l6.5-6.323a.5.5 0 00-.709-.709l-6.142 5.97-2.131-2.016a.5.5 0 00-.357-.147z"
          fill="#4caf50"
        />
      </svg>
    </span>
  );
}

export default SvgCheckcircle;
